<template>
    <div class="search_block">
        <input type="text" class="search_block_input" :placeholder="placeholderText" v-model="searchData" @input="inputSearch">
        <svg class="search_block_icon"></svg>
        <button class="search_block_icon_delete" :class="classDelete" @click.prevent="searchDataDelete"></button>
    </div>
</template>

<script>

export default {
    name: "search_block",
    props: {
        placeholderText: {
            type: String,
            required: true
        },
        searchDataDefault: {
            type: String,
            required: false,
            default: '',
        }
    },
    emits: ['search_input_data'],
    components: {},
    mixins: [],
    data() {
        return {
            searchData: '',
        }
    },
    beforeMount() {
        EventBus.$on('clear_search_data', this.searchDataDelete);
        EventBus.$on('loaded_filter_stop_list_products', this.loadFilterStopListProducts);
    },
    created() {
        if(this.searchDataDefault !== ''){
            this.searchData=this.searchDataDefault;
        }
    },
    beforeUnmount() {
        EventBus.$off('clear_search_data', this.searchDataDelete);
        EventBus.$off('loaded_filter_stop_list_products', this.loadFilterStopListProducts);
    },
    methods: {
        loadFilterStopListProducts(filterLoaded){
            if(filterLoaded.filter && filterLoaded.filter.search && filterLoaded.filter.search !== '') {
                this.searchData = filterLoaded.filter.search;
            }
        },
        inputSearch() {
            this.$emit('search_input_data', this.searchData);
        },
        searchDataDelete() {
            this.searchData = '';
            this.$emit('search_input_data', this.searchData);
        }

    },
    computed: {
        classDelete() {
            if (this.searchData.length > 0) {
                return {'show': true};
            }
            return {'show': false};
        },
    },
    watch: {}
}
</script>
